import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Button, { ButtonProps } from '@mui/material/Button';

export default Button;
export { Button, IconButton };
export type { ButtonProps, IconButtonProps };
